import styled from 'styled-components';
import { TrimSelectStyled } from '../TrimSelectStyled';
import { rem } from 'polished';

export const TrimSelectStyledAC = styled(TrimSelectStyled)`
    .trimTitle {
        color: ${({ theme }) => theme.colors.grey5};
        font-size: ${({ theme }) => theme.fontSizes.h4};
        .icon {
            background: ${({ theme }) => theme.colors.white};
            .selected {
                background: ${({ theme }) => theme.colors.blue2};
                width: ${rem(14)};
                height: ${rem(14)};
                top: ${rem(4)};
                left: ${rem(4)};
            }
        }
    }

    .trim {
        border-radius: ${rem(12)};

        &.isSelected,
        &:hover,
        &:focus-visible {
            border: 1px solid ${({ theme }) => theme.colors.blue2};
            .inner {
                border-color: ${({ theme }) => theme.colors.blue2};
                border-radius: ${rem(10)};
            }
        }
    }
    
    .trimContent {
        font-size: ${({ theme }) => theme.fontSizes.h5};
    }

    .isSelected {
        background: rgba(157, 199, 224, 0.2);
    }
`;
